// Hard-wrap a line to `width` columns like `gq`, keeping `code spans` and
// [links](url) intact and indenting continuation lines of list items.
const WORD = /`[^`]*`|\[[^\]]*\]\([^)]*\)|\S+/g;

// Visible width: link markup shows only its label plus the brackets.
const visible = (text) => text.replace(/\[([^\]]*)\]\([^)]*\)/g, '[$1]').length;

export function wrapLine(line, width) {
    if (visible(line) <= width) return [line];
    const list = line.startsWith('- ');
    const words = (list ? line.slice(2) : line).match(WORD) || [];
    const out = [];
    const lead = () => (list ? (out.length ? '  ' : '- ') : '');
    let cur = '';
    words.forEach((word) => {
        if (cur && visible(`${lead()}${cur} ${word}`) > width) {
            out.push(lead() + cur);
            cur = word;
        } else {
            cur = cur ? `${cur} ${word}` : word;
        }
    });
    if (cur) out.push(lead() + cur);
    return out;
}
